<template>
  <nav class="top-level-menu">
    <ul class="top-level-menu__list">
      <li v-for="(item, index) in menu.items" 
          :key="index"
          :class="topLevelItemClasses(item)" 
          @click="onTopLevelItemClick(item)">
        <template v-if="!isSeparator(item)">
          <div class="top-level-menu__trigger" :class="getClasses(item)" v-bind="getAttrs(item)" :name="`${prefix}top-menu-item-${index}`">
            <svg-icon v-if="!!item.icon" :icon="item.icon" class="top-level-menu__icon"/>
            <span v-if="item.targetUrl === '#'">{{ item.title }}</span>
            <a v-else :href="item.targetUrl">{{ item.title }}</a>
            <svg-icon v-if="isDropdownItem(item)" icon="lh:chevron/down" class="text-main-10" width="12" height="12"/>
          </div>
          <DropdownMenu v-if="item.items.length > 0"
                         class="top-level-menu__submenu"
                         :to="`${prefix}top-menu-item-${index}`"
                         :items="item.items"
                         key-href="targetUrl"
                         key-text="title"
                         key-children="items"
                         key-is-local-url="isLocalUrl"
          ></DropdownMenu>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import DropdownMenu from "./DropdownMenu2ComponentDesktop.vue";
import {MenuItemType} from "../types";

export default {
  components: {
    SvgIcon,
    DropdownMenu,
  },
  props: {
    menu: Object,
    prefix: String,
  },
  data() {
    return {};
  },
  methods: {
    getAttrs(item) {
      if (item.items.length > 0) {
        return {
        };
      }

      return {};
    },

    getClasses(item) {
      if (this.isDropdownItem(item)) {
        return {
        };
      }
      return {};
    },

    isDropdownItem(item) {
      return item.enabled && item.items.length > 0;
    },
    
    isSeparator(item) {
      return item.type === MenuItemType.Separator;
    },

    onTopLevelItemClick(item) {
      if(this.isSeparator(item) || item.enabled) {
        return;
      }

      if(!item.enabled) {
        this.$emit("top-level-disabled-item-click", item);
      }
    },
    
    topLevelItemClasses(item) {
      const isSeparator = this.isSeparator(item);
      return {
        'top-level-menu__item': true,
        'top-level-menu__item_disabled': !isSeparator && !item.enabled,
        'top-level-menu__item_separator': isSeparator, 
      };
    },
  }
};
</script>

<style lang="scss" scoped>

.top-level-menu {
  list-style-type: none;
}

.top-level-menu__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-flow: row nowrap;
  gap: 24px;
}

.top-level-menu__item {
  display: flex;  
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: var(--second-20);

  transition: color 0.2s ease-in-out;
  cursor: pointer;
  
  a {
    color: inherit;
    cursor: inherit;
  }

  &.top-level-menu__item_pad-left {
    margin-inline-start: 70px;
  }

  &:hover {
    color: var(--main-10);
  }

  &.top-level-menu__item_disabled {
    .top-level-menu__icon {
      color: var(--second-20);

    }

    &:hover {
      .top-level-menu__icon {
        color: var(--main-10);
      }
    }
  }
  
  &.top-level-menu__item_separator {
    width: 48px;
  }
}

.top-level-menu__icon {
  color: var(--main-10);
}

.top-level-menu__trigger {
  display: flex;
  padding: 4px 0;
  white-space: nowrap;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
}

</style>
